const Form011TC = {
    stepName: {
        Notes: "事項",
        SectionA: "個人資料",
        SectionB: "語言能力",
        SectionC: "工作",
        ExchangeProgramme: "交流計劃,興趣及才藝",
        FurtherInformation: "其他資料",
        Declaration: "聲明",
        Consent: "家長 / 監護人同意書",
        Confirmation: "確認",
    },
    title: {
        note: "注意",
        collectionPersonal: "個人資料收集",
        languageProficiency: "(B) 語言能力",
        languageProficiencyNote: "(a) 語言程度?",
        employment: "(C) 工作",
        personalParticulars: "(A) 個人資料",
        hkPersonTitle: "居港聯絡人資料",
        exchangeProgramme: "(D) 交流計劃",
        exchangeProgrammeTitle: "你過去曾否帶領其他學生交流計劃？",
        exchangeProgrammeTableTitle: "若有，請提供有關資料：",
        InterestsAndHobbies: "(E) 興趣及嗜好",
        InterestsAndHobbiesTableTitle:
            "請填上你的興趣及嗜好，並附上有關證明文件副本，如有：",
        part2: "第二部分",
        part2title: "推薦 - 由提名學校的校長填寫",
        undertakeTitle: `本人明白隨團教師及學生代表的選拔是獨立處理的。一旦獲提名教師入選，不論同樣獲本人提名參加「計劃」的學生(如有)是否獲選，本人承諾讓該教師於{{undertakeDate}}期內參加交流團。本人將敦促他 / 她出席所有活動及履行一切職務。`,
        furtherInformation: "(F) 其他資料",
        declaration: "(G) 聲明",
    },
    label: {
        japanese: "日語",
        english: "英文",
        putonghua: "普通話",
        proficiencyOptions: {
            fluent: "流利",
            canExpress: "略懂",
            cannotSpeak: "不懂",
        },
        remarks: "備註",
        everLearntJapanese: "(b) 你有否進修日語課程？",
        everLearntJapaneseOptions: {
            yes: "有",
            no: "沒有",
        },
        learntJapaneseNote: "若有，請提供有關資料，並附上有關證明文件副本：",
        courseName: "課程名稱",
        attainedLevel: "獲取程度",
        startOrCompletionDate: "開始 / 完結日期",
        schoolName: "學校名稱",
        schoolAddress: "學校地址",
        schoolTel: "電話號碼",
        schoolFax: "傳真號碼",
        positionHeld: "職位",
        positionHeldOptions: {
            assistantPrincipal: "副校長",
            seniorTeacher: "主任",
            teacher: "教師",
        },
        presentSchoolDate: "到校任教的日期",
        presentPostDate: "出任現職的日期",
        taughtTitle: "本學年任教高中的科目",
        taughtSubject: "任教科目",
        taughtLevel: "任教級別",
        taughtRemarks: "備註",
        headTitle: "非教學工作 （班主任 / 學會顧問 / 課外活動統籌等）",
        headPosition: "職位",
        natureOfDuty: "職務",
        period: "期間",
        periodFrom: "開始日期",
        periodTo: "完結日期",
        headRemarks: "備註",
        experienceTitle: "其他工作經驗 （包括非教學經驗及海外的工作經驗）",
        instituteName: "機構名稱",
        nameRemark: "姓名(請依香港特別行政區護照所示填寫)",
        englishName: "英文",
        chineseName: "中文",
        chineseCodeName: "姓名(中文姓名電碼)",
        birthDate: "出生日期",
        birthPlace: "出生地點",
        sex: "性别",
        hkIDNo: "香港身份證號碼",
        homeAddress: "住址",
        photoAttachment: "請上載照片",
        homeTel: "聯絡電話號碼",
        mobilePhone: "流動電話",
        eMailAddress: "電郵地址",
        faxNo: "傳真",
        hkSARPassportNumber: "你是否持有有效的香港特別行政區護照？",
        expiryDate: "屆滿日期",
        issueDate: "簽發日期",
        sexOption: {
            Male: "男",
            Female: "女",
        },
        hkPersonEnName: "姓名(英文)",
        hkPersonCnName: "姓名(中文)",
        hkPersonRelationship: "與獲提名人的關係",
        hkPersonAddress: "地址",
        hkPersonHomeTel: "住宅電話",
        hkPersonMobliePhone: "流動電話",
        hkPersonEmail: "電郵地址",
        hkPersonFax: "傳真",
        exchangeProgrammePeriod: "期間",
        exchangeProgrammeHostingOrganization: "主辦機構",
        exchangeProgrammePlace: "曾經到訪的地區 / 國家",
        exchangeProgrammePurpose: "到訪目的",
        exchangeProgrammeHostingRole: "職責",
        interestsOrHobbies: "興趣 / 嗜好",
        achievements: "成績（相關紀錄，如有）",
        gotFirstAidTraining: "(a) 你過去曾否接受急救訓練？",
        gotFirstAidTrainingTitle:
            "若有，請提供急救證書的有效日期，並附上有關的證明文件副本。",
        firstAidCertificateExpiryDate: "急救證書的有效日期(日／月／年)",
        trainUpStudentDelegatesArea:
            "(b) 請列出你能訓練學生代表的範疇，例如：簡單日語、演講、合唱等",
        supportingApplicationInformation:
            "(c) 請列出其他有助你申請的資料，如曾任日語翻譯等",
        attendActivities:
            "(d) 一旦獲選，你能否出席安排於星期六、日早上 / 下午及週日午後 / 黄昏舉行的活動？",
        attendActivitiesOptions: {
            yes: "可以",
            no: "不可以",
            notSure: "不肯定",
        },
        nomineeName: "獲提名人姓名",
        nominationReasons: "本人的提名是基於下列原因",
        principalName: "校長姓名",
        contactTel: "聯絡電話號碼",
        nomineeSign: "獲提名人簽署",
        presentPost: "現任職位",
        hasPassNoTips: "若有，請提供香港特別行政區護照屆滿日期",
        passNoExpireDate: "香港特別行政區護照屆滿日期（日／月／年）"
    },
    options: {
        hasPassNoOp: {
            yes: "有",
            no: "沒有",
        }
    },
    errorMsg: {
        englishName: "英文姓名",
        chineseName: "中文姓名",
    },
    note: {
        note1: "(a) 學校須於<b>{{deadline}}</b>遞交提名表格及相關文件。學校可透過統一登入系統(https://clo.edb.gov.hk/)遞交填妥的提名表格，並上載所需證明文件。",
        note2: "(b) 本表格內的資料將用於處理「計劃」的申請。",
        note3: `(c) 獲提名人須上載照片壹張於本表格上。`,
        note4: "(d)	如未能提供所需資料 / 文件，可能引致申請不獲接納。",
        note5: "(1)	教育局會用本表格所載的個人資料，作以下其中一種或多種用途：",
        note6: "(a)	辦理21世紀東亞青少年大交流計劃的申請；及",
        note7: "(b)	進行有關的研究及編製統計資料，以便規劃有關的教育服務。",
        note8: "(2)	你必須在本表格上填寫個人資料，如不能提供這些資料，申請的處理工作及結果或會受影響。",
        note9: "(3)	本表格所蒐集的個人資料，或會向其他政府部門 / 決策局或接待機構披露，作上文所述用途。",
        note10: "(4) 根據《個人資料（私隱）條例》第18和22條及附表1第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note11: "(5) 如欲查詢有關本表格所蒐集的個人資料，包括要查閱及改正資料事宜，請向教育局延伸支援計劃組提出，地址為香港灣仔皇后大道東213號胡忠大廈11樓1141室 （電話號碼：2892 6663）。",
        note12: "(a) 本人聲明，上述所填報的資料均屬真確無訛。",
        note13: "(b) 本人承諾一旦獲選，定當：",
        note14: "盡忠職守，並為學生代表樹立良好榜樣；",
        note15: "出席所有出發前的會議、訓練、簡介會及綵排活動等；",
        note16: "籌劃才藝表演及訓練學生代表；",
        note17: "帶領學生代表製訂有關香港的資料以備向接待機構講解；",
        note18: "協助代表團的行政工作及出發前的綵排活動；",
        note19: "領導學生代表小組，並履行隨團教師的有關職務；",
        note20: "隨團照顧學生代表及處理他們的紀律及行為問題；",
        note21: "於外訪結束後完成此行的個人評估表；",
        note22: "指導學生代表於外訪結束後一個半月內完成交流成果小組報告；",
        note23: "於外訪結束後兩個月內完成有關此行的報告，並分享如何讓學生代表從「計劃」中獲益的經驗；及",
        note24: "應教育局及 / 或贊助機構的邀請或要求，出席相關活動。",
        note25: "填妥的提名表格須連同下列文件一併提交：",
        note26: "(a) 正面半身近照一張；",
        note27: "(b) 其他有助教師提名的證明文件副本；",
        note28: "(c) 通曉 / 學習日語的證明文件副本，如有；及",
        note29: "(d) 急救證書副本，如有。",
    },
};

export default Form011TC;

